import useGtmButtonTracking from './useGtmButtonTracking';
import useGtmCheckboxTracking from './useGtmCheckboxTracking';
import useGtmDropdownTracking from './useGtmDropdownTracking';
import useGtmLinkTracking from './useGtmLinkTracking';
import useGtmRadioButtonTracking from './useGtmRadioButtonTracking';
import useGtmSearchTracking from './useGtmSearchTracking';
import useGtmTextFieldTracking from './useGtmTextFieldTracking';
import useGtmToggleChangeTracking from './useGtmToggleChangeTracking';
import useGtmToggleIntentTracking from './useGtmToggleIntentTracking';
import useGtmValidationErrorTracking from './useGtmValidationErrorTracking';

// INFORMATION REGARDING THE USE OF { capture: true } in the below listed event listeners
// These global listeners use { capture: true }, which means they will ALWAYS fire first, regardless of any stopPropagation() calls.
// Here's why:

// Event Flow:
// 1. CAPTURE phase (top → down) ← Your listeners fire here FIRST
// 2. TARGET phase
// 3. BUBBLE phase (bottom → up) ← stopPropagation() blocks THIS phase

export default function useGlobalGtmListeners() {
  useGtmButtonTracking();
  useGtmLinkTracking();
  useGtmRadioButtonTracking();
  useGtmCheckboxTracking();
  useGtmSearchTracking();
  useGtmDropdownTracking();
  useGtmValidationErrorTracking();
  useGtmTextFieldTracking();
  useGtmToggleIntentTracking();
  useGtmToggleChangeTracking();
}
